import React, { useState } from "react";
import { Button, Card, Col, Collapse, Row, Space, Typography } from "antd";
import { useResponsive } from "../../utils/use-responsive";
import styles from "./customer-card.module.scss";

const { Panel } = Collapse;
const { Title, Text } = Typography;

export const CustomerDocumentsCard: React.FC<{
  title: string;
  tooltip?: string;
  icon: string;
  details: string;
  extras?: Object;
  optional?: boolean;
}> = ({ title, tooltip, icon, details, extras = false, optional = false }) => {
  const { isXs } = useResponsive();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  function showOptionalOrIcon() {
    if (!isXs && !optional) {
      return (
        <div className={styles["cardIcon"]}>
          <img alt="Icon" src={icon} />
        </div>
      );
    } else if (!isXs && optional) {
      return (
        <Row justify="space-between">
          <img alt="Icon" src={icon} />
          <Text type="secondary">Optional</Text>
        </Row>
      );
    }
  }

  return (
    <Col xs={24} sm={12} md={12} lg={12} xl={12}>
      <Card style={{ borderRadius: "8px" }}>
        <Space direction={"vertical"} size={"middle"} className={"full-width"}>
          {showOptionalOrIcon()}

          <Row typeof="flex" justify="space-between">
            <Col typeof="flex" className={!isXs ? "" : "full-width"}>
            <Space.Compact direction={"vertical"} className={"full-width"}>
            <Space
                  direction={"horizontal"}
                  size={"small"}
                  className={"ant-row-space-between"}
                >
                  <Space direction={"horizontal"} size={"small"}>
                  <Title level={3} style={{ margin: 0, fontWeight: "lighter" }}>
                {title}
              </Title>
                  </Space>
                  {isXs && !optional && <img alt="Icon" src={icon} />}
                </Space>
              
              </Space.Compact>
            </Col>
            <Col typeof="flex" className={!isXs ? "" : "full-width"}>
              <Button
                block
                className="manageBtn"
                size="large"
                style={{ width: isXs ? "100%" : "250px" }}
              >
                Manage
              </Button>
            </Col>
          </Row>
        </Space>
      </Card>
    </Col>
  );
};
